import { useEffect, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { notify } from "../Toast/Toast";

export default function WorkWithUs({ buttonStyle }) {
	const [showModal, setShowModal] = useState(false);
	const [currentLanguage, setCurrentLanguage] = useState("");
	const [currentQualification, setCurrentQualification] = useState("");
	const { formValues, handleChange, handleSubmit, isLoading, alertMessage } = useForm("jobs-seekers", "POST", true, true);

	const handleCloseModal = () => {
		setShowModal(false);
	};

	const handleWorkWithUsModal = () => {
		setShowModal(true);
	};

	// Handle adding a new language to the array
	const handleAddLanguage = () => {
		if (currentLanguage.trim()) {
			const updatedLanguages = [...(formValues.languages || []), currentLanguage.trim()];
			handleChange({
				target: {
					name: "languages",
					value: updatedLanguages,
				},
			});
			setCurrentLanguage("");
		}
	};

	// Handle removing a language from the array
	const handleRemoveLanguage = (indexToRemove) => {
		const updatedLanguages = (formValues.languages || []).filter((_, index) => index !== indexToRemove);
		handleChange({
			target: {
				name: "languages",
				value: updatedLanguages,
			},
		});
	};

	// Handle adding a new qualification to the array
	const handleAddQualification = () => {
		if (currentQualification.trim()) {
			const updatedQualifications = [...(formValues.qualifications || []), currentQualification.trim()];
			handleChange({
				target: {
					name: "qualifications",
					value: updatedQualifications,
				},
			});
			setCurrentQualification("");
		}
	};

	// Handle removing a qualification from the array
	const handleRemoveQualification = (indexToRemove) => {
		const updatedQualifications = (formValues.qualifications || []).filter((_, index) => index !== indexToRemove);
		handleChange({
			target: {
				name: "qualifications",
				value: updatedQualifications,
			},
		});
	};

	// Custom handleSubmit to ensure languages is an array
	// Replace your customHandleSubmit with this version
	const handleFormSubmit = (e) => {
		e.preventDefault();

		// Ensure languages is always an array
		const languagesArray = formValues.languages && formValues.languages.length > 0 ? formValues.languages : currentLanguage ? [currentLanguage] : [];
		const qualificationsArray =
			formValues.qualifications && formValues.qualifications.length > 0 ? formValues.qualifications : currentQualification ? [currentQualification] : [];

		if (languagesArray.length === 0 && formValues.profession !== "Admin") {
			notify("Please add at least one language", "fas fa-exclamation-circle");
			return;
		}

		if (qualificationsArray.length === 0) {
			notify("Please add at least one qualification", "fas fa-exclamation-circle");
			return;
		}

		// Create FormData object
		const formData = new FormData();

		// Append all regular fields
		Object.entries(formValues).forEach(([key, value]) => {
			if (key !== "languages" && key !== "qualifications" && key !== "cv" && value !== undefined && value !== null) {
				formData.append(key, value);
			}
		});

		// Append languages in field[] format
		languagesArray.forEach((lang) => {
			formData.append("languages[]", lang);
		});

		// Append qualifications in field[] format
		qualificationsArray.forEach((qual) => {
			formData.append("qualifications[]", qual);
		});

		// Append CV file if exists
		if (formValues.cv && formValues.cv[0]) {
			formData.append("cv", formValues.cv[0]);
			// If your backend expects array format:
			// formData.append("cv[]", formValues.cv[0]);
		}

		// Create mock event for useForm's handleSubmit
		const mockEvent = {
			preventDefault: () => {},
			target: {
				...e.target,
				values: {
					...formValues,
					languages: languagesArray,
				},
			},
		};

		handleSubmit(mockEvent);
	};

	useEffect(() => {
		if (showModal) {
			document.body.style.overflow = "hidden";
			document.body.style.paddingRight = "15px";
		} else {
			document.body.style.overflow = "";
			document.body.style.paddingRight = "";
		}

		// Cleanup function
		return () => {
			document.body.style.overflow = "";
			document.body.style.paddingRight = "";
		};
	}, [showModal]);
	return (
		<>
			<div
				className='services-card'
				style={{
					paddingTop: "10px",
					paddingBottom: "10px",
					paddingLeft: "25px",
					paddingRight: "25px",
					fontWeight: "bold",
					cursor: "pointer",
					boxShadow: "0 0 30px 10px rgba(0, 0, 0, 0.4)",
					background: `linear-gradient(${showModal ? "#4a259b" : "#4a259b"}, ${showModal ? "white" : "#4a259b"})`,
					borderLeft: showModal ? "10px solid #4a259b" : "10px solid #e5e0f1",
					width: "50%",
				}}
				onClick={handleWorkWithUsModal}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						height: "100%",
					}}
				>
					<h6
						style={{
							color: showModal ? "#4a259b" : "white",
							fontSize: buttonStyle.fontSize,
							margin: "0px",
							fontWeight: "bold",
							lineHeight: "1.4rem",
						}}
					>
						Work With Us
					</h6>
				</div>
			</div>

			{showModal && (
				<div
					className='modal-backdrop'
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(0,0,0,0.5)",
						zIndex: 1050,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						className='modal-content'
						style={{
							backgroundColor: "white",
							borderRadius: "8px",
							maxWidth: "600px",
							width: "90%",
							maxHeight: "90vh",
							overflowY: "auto",
							zIndex: 1051,
							position: "relative",
						}}
					>
						<div className='modal-header' style={{ backgroundColor: "white", justifyContent: "center" }}>
							<div className='container services-card py-5 pt-1 mt-4 pb-3 align-items-center justify-content-center text-center' style={{ width: "280px" }}>
								<i className='fa-solid fa-handshake' style={{ fontSize: "3rem", color: "#4a259b" }}></i>
								<h4
									style={{
										color: "#4a259b",
										fontSize: "17px",
										textAlign: "center",
										paddingTop: "5px",
									}}
								>
									Join Our Team
								</h4>
								<p
									style={{
										fontSize: "0.8rem",
										textAlign: "center",
										fontFamily: "gothic",
									}}
								>
									Submit your details and we'll get back to you soon.
								</p>
							</div>
							<button
								onClick={handleCloseModal}
								style={{
									position: "absolute",
									right: "20px",
									top: "20px",
									background: "none",
									border: "none",
									fontSize: "1.5rem",
									cursor: "pointer",
								}}
							>
								×
							</button>
						</div>

						<div className='modal-body' style={{ padding: "20px" }}>
							<form onSubmit={handleFormSubmit} style={{ fontFamily: "gothic" }} encType='multipart/form-data'>
								{/* Other form fields remain the same */}
								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Name:</label>
									<input type='text' className='form-control' name='name' value={formValues.name || ""} onChange={handleChange} required />
								</div>

								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Email:</label>
									<input type='email' className='form-control' name='email' value={formValues.email || ""} onChange={handleChange} required />
								</div>

								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Contact number:</label>
									<input type='tel' className='form-control' name='contactNumber' value={formValues.contactNumber || ""} onChange={handleChange} required />
								</div>

								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Profession:</label>
									<select className='form-control' name='profession' value={formValues.profession || ""} onChange={handleChange} required>
										<option value=''>Select your profession</option>
										<option value='Translator'>Translator</option>
										<option value='Interpreter'>Interpreter</option>
										<option value='Admin'>Admin</option>
									</select>
								</div>

								{formValues.profession !== "Admin" && (
									<div className='form-group mb-3' style={{ textAlign: "left" }}>
										<label>Languages:</label>
										<div className='input-group mb-2'>
											<input
												type='text'
												className='form-control'
												value={currentLanguage}
												onChange={(e) => setCurrentLanguage(e.target.value)}
												placeholder='Add language (press Enter or click Add)'
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														e.preventDefault();
														if (currentLanguage.trim()) {
															handleAddLanguage();
														}
													}
												}}
											/>
											<button
												type='button'
												className='btn btn-primary'
												onClick={() => {
													if (currentLanguage.trim()) {
														handleAddLanguage();
													}
												}}
											>
												Add
											</button>
										</div>

										<div className='d-flex flex-wrap gap-2 mb-2'>
											{(formValues.languages || []).map((language, index) => (
												<div key={index} className='badge bg-primary d-flex align-items-center'>
													{language}
													<button
														type='button'
														className='btn-close btn-close-white ms-2'
														style={{ fontSize: "0.5rem" }}
														onClick={() => handleRemoveLanguage(index)}
														aria-label='Remove language'
													/>
												</div>
											))}
										</div>
									</div>
								)}
								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Years of experience:</label>
									<input
										type='number'
										className='form-control'
										name='yearsOfExperience'
										value={formValues.yearsOfExperience || ""}
										onChange={handleChange}
										min='0'
										required
									/>
								</div>

								<div className='form-group mb-3' style={{ textAlign: "left" }}>
									<label>Qualifications:</label>
									<div className='input-group mb-2'>
										<input
											type='text'
											className='form-control'
											value={currentQualification}
											onChange={(e) => setCurrentQualification(e.target.value)}
											placeholder='Add qualification (press Enter or click Add)'
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													e.preventDefault();
													if (currentQualification.trim()) {
														handleAddQualification();
													}
												}
											}}
										/>
										<button
											type='button'
											className='btn btn-primary'
											onClick={() => {
												if (currentQualification.trim()) {
													handleAddQualification();
												}
											}}
										>
											Add
										</button>
									</div>

									<div className='d-flex flex-wrap gap-2 mb-2'>
										{(formValues.qualifications || []).map((qualification, index) => (
											<div key={index} className='badge bg-primary d-flex align-items-center'>
												{qualification}
												<button
													type='button'
													className='btn-close btn-close-white ms-2'
													style={{ fontSize: "0.5rem" }}
													onClick={() => handleRemoveQualification(index)}
													aria-label='Remove qualification'
												/>
											</div>
										))}
									</div>
								</div>

								<div className='form-group mb-4'>
									<label>Upload your CV:</label>
									<input type='file' className='form-control' name='cv' onChange={handleChange} accept='.pdf,.doc,.docx' required />
									<small className='text-muted'>PDF, DOC, or DOCX files only</small>
								</div>

								<div className='modal-footer' style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
									<button type='button' className='btn' onClick={handleCloseModal} style={{ backgroundColor: "#4a259b", color: "white" }}>
										Close
									</button>
									<button type='submit' className='btn' style={{ backgroundColor: "#4a259b", color: "white" }} disabled={isLoading}>
										{isLoading ? "Submitting..." : "Submit Application"}
									</button>
								</div>
							</form>
						</div>

						{alertMessage && <div className={`alert alert-${alertMessage.type === "success" ? "success" : "danger"}`}>{alertMessage.message}</div>}
					</div>
				</div>
			)}
		</>
	);
}
